<template>
  <div class="auth-page reset-page">
    <div ref="parentRef" class="auth-page__fields">
      <UIButton id="back-button" left-icon="back" class="auth-page__back" variant="ghost" @click="handleBack">
        Back
      </UIButton>
      <template v-if="isSuccess">
        <div class="auth-page__title auth-page__title--success">Check your e-mail {{ values.email }}</div>
        <form class="auth-page__form">
          <p class="auth-page__note">
            We’ve sent reset password link on your <br />
            e-mail. Please use this link to reset your password.
          </p>
          <img class="reset-page__image" src="/images/reset-mail.png" width="192" height="192" alt="Smiling mail" />
        </form>
      </template>
      <template v-else>
        <div class="auth-page__title">Reset password</div>

        <form class="auth-page__form" @submit.prevent="onSubmit">
          <p class="auth-page__note">
            Enter the email you used to create your account, and we’ll send you instructions to reset your password.
          </p>
          <UIInputText name="email" label="Email" placeholder="Email" />
          <UIButton id="reset-instructions" :loading="isPending" type="submit" full-width
            >Send me reset instructions</UIButton
          >
        </form>
      </template>
    </div>
    <div class="auth-page__img">
      <img width="521" height="714" src="/images/login-page-image.png" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useForm } from 'vee-validate'
import { SITE_NAME } from '~/constants'
import resetPasswordSchema from '~/schemas/auth/reset'

useHead({
  title: `${SITE_NAME} | Reset password`,
})

definePageMeta({
  layout: 'auth',
  middleware: 'is-auth-route',
})

const handleBack = () => {
  if (isSuccess.value) {
    reset()

    return
  }

  navigateTo({ name: 'login-email' })
}

const { handleSubmit, values } = useForm<{
  email: string
}>({
  validationSchema: resetPasswordSchema,
  keepValuesOnUnmount: true,
})

const { mutateAsync: forgot, isPending, isSuccess, reset } = useForgotPassword()

const { catchErrors } = useErrorHandler()

const onSubmit = handleSubmit(values => {
  forgot(values).catch(catchErrors)
})

const [parentRef] = useAutoAnimate()
</script>

<style scoped lang="scss">
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

@include baseAuthPage();

.auth-page {
  &__title {
    &--success {
      text-align: left;
      max-width: 322px;
      margin: 0 auto 32px auto;

      @media screen and (max-width: 1023px) {
        margin: auto auto 8px auto;
        max-width: 280px;
      }
    }
  }

  &__note {
    margin-bottom: 0;
  }

  @media screen and (max-width: 1023px) {
    &__form {
      margin-bottom: auto;
    }

    &__fields {
      margin-bottom: 48px;
    }
  }
}

.reset-page {
  &__image {
    margin: 16px auto 0 auto;
  }
}
</style>
